'use client';

import React, { createContext, useContext, useState } from 'react';

type VideoPlayerContextType = {
  activeVideoRef: React.RefObject<HTMLVideoElement | null> | null;
  setActiveVideo: (videoRef: React.RefObject<HTMLVideoElement | null>) => void;
};

const VideoPlayerContext = createContext<VideoPlayerContextType>({
  activeVideoRef: null,
  setActiveVideo: () => {},
});

export const VideoPlayerProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeVideoRef, setActiveVideoRefState] = useState<React.RefObject<HTMLVideoElement | null> | null>(null);

  const setActiveVideo = (videoRef: React.RefObject<HTMLVideoElement | null>) => {
    // Wenn es bereits ein aktives Video gibt, pausiere es
    if (activeVideoRef && activeVideoRef !== videoRef && activeVideoRef.current) {
      activeVideoRef.current.pause();
    }

    // Setze das neue Video als aktiv
    setActiveVideoRefState(videoRef);
  };

  return (
    <VideoPlayerContext.Provider value={{ activeVideoRef, setActiveVideo }}>
      {children}
    </VideoPlayerContext.Provider>
  );
};

export const useVideoPlayerContext = () => useContext(VideoPlayerContext); 